module.exports = __webpack_public_path__ + "static/media/CircularPro-Bold.7ce51a95.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/CircularPro-Bold.ttf
// module id = 111
// module chunks = 0